{
    "CodeList_Column_Description": "Beschreibung",
    "CodeList_Column_Code": "Code",
    "CodeList_Column_Type": "Typ",
    "CodeList_Column_TelSys": "Telefonieserver",
    "CodeList_Column_Partition": "Partition",
    "CodeList_Partition_Any": "Beliebig",
    "CodeList_Scope_All": "Alle",
    "CodeList_Scope_ServiceWide": "Serviceweit",
    "CodeList_Scope_SystemWide": "Systemweit",
    "CodeList_Scope_Detached": "Losgelöst",
    "CodeList_Type_All": "Alle",
    "CodeList_Type_Account": "Konto",
    "CodeList_Type_ACD_NotAvailable": "ACD nicht verfügbar",
    "CodeList_Scope_Label": "Umfang",
    "CodeList_Type_Label": "Typ",
    "CodeList_Change_AnyPartitionNotSupported": "Codes in der Partition „Beliebig“ können hier weder bearbeitet noch angezeigt werden. Filtern Sie die Liste nach einer bestimmten Partition, um einen Code zu ändern oder anzuzeigen.",
    "NAME": "CodeListLanguage"
}